import React, { useState, useEffect } from "react";
import { LoadingIcon } from '@prosolve/common-components-ui'
import Cookies from 'js-cookie';
import useFetch from '../../hooks/useFetch';

export default () => {
  const userId = Cookies.get('loggedInUserId');

  const [isLoading, setIsLoading] = useState(true)
  const [summaryData, setSummaryData] = useState({});

  const fetch = useFetch();

  const fetchSummaryData = async () => {
    setIsLoading(true)
    try {
      const response = await fetch(`trainer/summary?userId=${userId}`, { method: 'GET' })
      const jsonData = await response.json();
      if (jsonData.error) {
        setSummaryData({})
      } else {
        setSummaryData(jsonData)
      }
    } catch (e) {
      setSummaryData({})
    }
    setIsLoading(false)
  }

  useEffect(() => {
    fetchSummaryData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const {
    totalModules,
    totalCompensation,
  } = summaryData;

  const SummaryBlock = ({ name, value }) => {
    return (
      <div style={{
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        padding: '20px',
        border: '1px solid #dcdcdc',
        borderRadius: '10px',
        maxWidth: '300px'
      }}>
        <div style={{
          color: '#a5a5a5',
          fontSize: '18px',
          fontWeight: 'bold',
          marginBottom: '20px'
        }}>
          {name}
        </div>
        <div style={{
          color: '#565656',
          fontSize: '65px',
          fontWeight: 'bold',
          textAlign: 'center'
        }}>
          {value}
        </div>
      </div>
    )
  }

  return (
    <div
      style={{
        padding: '20px',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <div style={{
        flex: 1,
        color: '#565656',
        fontSize: '24px',
        fontWeight: 'bold',
        marginLeft: '20px'
      }}>
        {`Summary`}
      </div>
      {
        isLoading ?
          <div style={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            padding: '20px'
          }}>
            <LoadingIcon />
          </div>
          :
          <div style={{
            flex: 1,
            display: 'flex',
            columnGap: '20px',
            rowGap: '20px',
            padding: '20px',
            flexWrap: 'wrap'
          }}>
            <SummaryBlock name="Total Modules" value={totalModules || '0'} />
            <SummaryBlock name="Total Compensation" value={totalCompensation || '0'} />
          </div>
      }
    </div>
  )
}